import {useQuery} from '@tanstack/react-query';

import {getSportMatch, SPORT_CATEGORY_SLUGS} from '../api';
import {SportMatchDTO} from '../api/types';

export const useGetSportMatch = (
  categorySlug: string | undefined,
  matchId: string | undefined,
) => {
  const slug = categorySlug?.toLowerCase();
  return useQuery<SportMatchDTO>({
    queryKey: ['sportMatch', slug, matchId],
    queryFn: () => getSportMatch(slug!, matchId!),
    enabled: !!slug && !!matchId && SPORT_CATEGORY_SLUGS.includes(slug),
  });
};
